 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Cancion 01":"Cancion 01","Leccion1A":"Leccion1A","Leccion1B":"Leccion1B","Leccion1b":"Leccion1b","Leccion1c":"Leccion1c","Leccion1d":"Leccion1d","Leccion1e":"Leccion1e","Leccion1f":"Leccion1f","Leccion2A":"Leccion2A","Leccion2SB":"Leccion2SB","Leccion2b":"Leccion2b","Leccion2c":"Leccion2c","Leccion2d":"Leccion2d","Leccion2f":"Leccion2f","Leccion3A":"Leccion3A","Leccion3SB":"Leccion3SB","Leccion3b":"Leccion3b","Leccion3c":"Leccion3c","Leccion3d":"Leccion3d","Leccion3f":"Leccion3f","Leccion4A":"Leccion4A","Leccion4SB":"Leccion4SB","Leccion4b":"Leccion4b","Leccion4c":"Leccion4c","Leccion4d":"Leccion4d","Leccion4f":"Leccion4f","Leccion5A":"Leccion5A","Leccion5SB":"Leccion5SB","Leccion5b":"Leccion5b","Leccion5c":"Leccion5c","Leccion5d":"Leccion5d","Leccion5f":"Leccion5f","Leccion6A":"Leccion6A","Leccion6SB":"Leccion6SB","Leccion6b":"Leccion6b","Leccion6c":"Leccion6c","Leccion6d":"Leccion6d","Leccion6f":"Leccion6f","cancion 02":"cancion 02","cancion 03":"cancion 03","cancion 04":"cancion 04","cancion 05":"cancion 05","cancion 06":"cancion 06","cancion 07":"cancion 07","cancion 08":"cancion 08","cancion 09":"cancion 09","cancion 10":"cancion 10","cancion 11":"cancion 11","cancion 12":"cancion 12","cancion 13":"cancion 13","leccion1a":"leccion1a","leccion2a":"leccion2a","leccion3a":"leccion3a","leccion4a":"leccion4a","leccion5a":"leccion5a","leccion6a":"leccion6a"}[chunkId]||chunkId) + "." + {"Cancion 01":"f5c420dd","Leccion1A":"c9b607cf","Leccion1B":"9883b211","Leccion1b":"57efbf1d","Leccion1c":"c63cf7b3","Leccion1d":"77b280a7","Leccion1e":"3bebd726","Leccion1f":"857dcb4c","Leccion2A":"427d4115","Leccion2SB":"4e6a39e1","Leccion2b":"ebeb9d88","Leccion2c":"ec1f0d30","Leccion2d":"3f422204","Leccion2f":"f157ce0d","Leccion3A":"e347641d","Leccion3SB":"b9ad6124","Leccion3b":"cb2de387","Leccion3c":"4398e668","Leccion3d":"769cfb2c","Leccion3f":"7773dfa5","Leccion4A":"22e1483f","Leccion4SB":"70dca272","Leccion4b":"61d18c47","Leccion4c":"11cdd51e","Leccion4d":"4cf21382","Leccion4f":"08665b65","Leccion5A":"0abcedc4","Leccion5SB":"eb56720a","Leccion5b":"be04f490","Leccion5c":"3fc80b1e","Leccion5d":"c3cb4b91","Leccion5f":"d721060a","Leccion6A":"89351d98","Leccion6SB":"b3cfa332","Leccion6b":"ee7c91f6","Leccion6c":"b8d862c7","Leccion6d":"e53f174f","Leccion6f":"85a930ff","cancion 02":"6d033157","cancion 03":"b6152f7d","cancion 04":"803befe1","cancion 05":"a26c1a74","cancion 06":"4c297b37","cancion 07":"06130bed","cancion 08":"d0818122","cancion 09":"6ea5ecfd","cancion 10":"1eb3f034","cancion 11":"0e284d42","cancion 12":"e1e1c170","cancion 13":"9c804220","leccion1a":"7ff8c761","leccion2a":"9cd03288","leccion3a":"b821a486","leccion4a":"a2367156","leccion5a":"131874b1","leccion6a":"73499a53"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Cancion 01":1,"Leccion1A":1,"Leccion1B":1,"Leccion1b":1,"Leccion1c":1,"Leccion1d":1,"Leccion1e":1,"Leccion1f":1,"Leccion2A":1,"Leccion2SB":1,"Leccion2b":1,"Leccion2c":1,"Leccion2d":1,"Leccion2f":1,"Leccion3A":1,"Leccion3SB":1,"Leccion3b":1,"Leccion3c":1,"Leccion3d":1,"Leccion3f":1,"Leccion4A":1,"Leccion4SB":1,"Leccion4b":1,"Leccion4c":1,"Leccion4d":1,"Leccion4f":1,"Leccion5A":1,"Leccion5SB":1,"Leccion5b":1,"Leccion5c":1,"Leccion5d":1,"Leccion5f":1,"Leccion6A":1,"Leccion6SB":1,"Leccion6b":1,"Leccion6c":1,"Leccion6d":1,"Leccion6f":1,"cancion 02":1,"cancion 03":1,"cancion 04":1,"cancion 05":1,"cancion 06":1,"cancion 07":1,"cancion 08":1,"cancion 09":1,"cancion 10":1,"cancion 11":1,"cancion 12":1,"cancion 13":1,"leccion1a":1,"leccion2a":1,"leccion3a":1,"leccion4a":1,"leccion5a":1,"leccion6a":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Cancion 01":"Cancion 01","Leccion1A":"Leccion1A","Leccion1B":"Leccion1B","Leccion1b":"Leccion1b","Leccion1c":"Leccion1c","Leccion1d":"Leccion1d","Leccion1e":"Leccion1e","Leccion1f":"Leccion1f","Leccion2A":"Leccion2A","Leccion2SB":"Leccion2SB","Leccion2b":"Leccion2b","Leccion2c":"Leccion2c","Leccion2d":"Leccion2d","Leccion2f":"Leccion2f","Leccion3A":"Leccion3A","Leccion3SB":"Leccion3SB","Leccion3b":"Leccion3b","Leccion3c":"Leccion3c","Leccion3d":"Leccion3d","Leccion3f":"Leccion3f","Leccion4A":"Leccion4A","Leccion4SB":"Leccion4SB","Leccion4b":"Leccion4b","Leccion4c":"Leccion4c","Leccion4d":"Leccion4d","Leccion4f":"Leccion4f","Leccion5A":"Leccion5A","Leccion5SB":"Leccion5SB","Leccion5b":"Leccion5b","Leccion5c":"Leccion5c","Leccion5d":"Leccion5d","Leccion5f":"Leccion5f","Leccion6A":"Leccion6A","Leccion6SB":"Leccion6SB","Leccion6b":"Leccion6b","Leccion6c":"Leccion6c","Leccion6d":"Leccion6d","Leccion6f":"Leccion6f","cancion 02":"cancion 02","cancion 03":"cancion 03","cancion 04":"cancion 04","cancion 05":"cancion 05","cancion 06":"cancion 06","cancion 07":"cancion 07","cancion 08":"cancion 08","cancion 09":"cancion 09","cancion 10":"cancion 10","cancion 11":"cancion 11","cancion 12":"cancion 12","cancion 13":"cancion 13","leccion1a":"leccion1a","leccion2a":"leccion2a","leccion3a":"leccion3a","leccion4a":"leccion4a","leccion5a":"leccion5a","leccion6a":"leccion6a"}[chunkId]||chunkId) + "." + {"Cancion 01":"ce2239e7","Leccion1A":"ce2239e7","Leccion1B":"ce2239e7","Leccion1b":"ce2239e7","Leccion1c":"ce2239e7","Leccion1d":"ce2239e7","Leccion1e":"ce2239e7","Leccion1f":"ce2239e7","Leccion2A":"ce2239e7","Leccion2SB":"ce2239e7","Leccion2b":"ce2239e7","Leccion2c":"ce2239e7","Leccion2d":"ce2239e7","Leccion2f":"ce2239e7","Leccion3A":"ce2239e7","Leccion3SB":"ce2239e7","Leccion3b":"ce2239e7","Leccion3c":"ce2239e7","Leccion3d":"ce2239e7","Leccion3f":"ce2239e7","Leccion4A":"ce2239e7","Leccion4SB":"ce2239e7","Leccion4b":"ce2239e7","Leccion4c":"ce2239e7","Leccion4d":"ce2239e7","Leccion4f":"ce2239e7","Leccion5A":"ce2239e7","Leccion5SB":"ce2239e7","Leccion5b":"ce2239e7","Leccion5c":"ce2239e7","Leccion5d":"ce2239e7","Leccion5f":"ce2239e7","Leccion6A":"ce2239e7","Leccion6SB":"ce2239e7","Leccion6b":"ce2239e7","Leccion6c":"ce2239e7","Leccion6d":"ce2239e7","Leccion6f":"ce2239e7","cancion 02":"ce2239e7","cancion 03":"ce2239e7","cancion 04":"ce2239e7","cancion 05":"ce2239e7","cancion 06":"ce2239e7","cancion 07":"ce2239e7","cancion 08":"ce2239e7","cancion 09":"ce2239e7","cancion 10":"ce2239e7","cancion 11":"ce2239e7","cancion 12":"ce2239e7","cancion 13":"ce2239e7","leccion1a":"ce2239e7","leccion2a":"ce2239e7","leccion3a":"ce2239e7","leccion4a":"ce2239e7","leccion5a":"ce2239e7","leccion6a":"ce2239e7"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
